import { render, staticRenderFns } from "./DisciplinesMultiDomainData.vue?vue&type=template&id=533ea5a2&scoped=true&"
import script from "./DisciplinesMultiDomainData.vue?vue&type=script&setup=true&lang=js&"
export * from "./DisciplinesMultiDomainData.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DisciplinesMultiDomainData.vue?vue&type=style&index=0&id=533ea5a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ea5a2",
  null
  
)

export default component.exports